import React from 'react';
import { useSelector } from 'react-redux';
//import { Link } from 'react-router-dom';

import classes from './Projects.module.scss';
import Weather from '../assets/Project/weather.svg';
import Quiz from '../assets/Project/quiz.svg';
import Calculator from '../assets/Project/calculator.svg';

const Projects = () => {
    const darkMode = useSelector(state => state.darkMode)
    //const projects = useSelector(state => state.Projects)

    let mode = null;

    if(darkMode){
        mode = classes.InfoDark
    } else {
        mode = classes.InfoLight
    }

    /* const cards = projects.map( (pr) => (
        <div className={classes.Card}>
                        <section className={classes.Logo}><img src={JSON.stringify(pr.logo)} alt="Weather"/></section>
                        <section className={classes.Description}>
                            <p>{pr.title}</p>
                            <a href={pr.address} target="_blank" rel="noreferrer"><button>View Deployment</button></a>
                        </section>
                    </div>
    )) */

    return (
        <div className={classes.ScrollSnap} id='projects'>
            <div className={classes.Header}>
                <h1>Projects</h1>
            </div>
            <div className={mode}>
                <div className={classes.Cards}>
                    <div className={classes.Card}>
                        <section className={classes.Logo}><img src={Weather} alt="Weather"/></section>
                        <section className={classes.Description}>
                            <p>Weather Forecast</p>
                            <a href="https://parthpakhare.github.io/react-weather-app/" target="_blank" rel="noreferrer"><button>View Deployment</button></a>
                        </section>
                    </div>
                    <div className={classes.Card}>
                        <section className={classes.Logo}><img src={Quiz} alt="Trivia"/></section>
                        <section className={classes.Description}>
                            <p>Trivia</p>
                            <a href="https://parthpakhare.github.io/quizapp/" target="_blank" rel="noreferrer"><button>View Deployment</button></a>
                        </section>
                    </div>
                    <div className={classes.Card}>
                        <section className={classes.Logo}><img src={Calculator} alt="Calculator"/></section>
                        <section className={classes.Description}>
                            <p>Simple Calculator</p>
                            <a href="https://parthpakhare.github.io/calculator/" target="_blank" rel="noreferrer"><button>View Deployment</button></a>
                        </section>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default Projects